interface AppStateSlice {
    showSigningInInventory: boolean;
    setShowSigningInInventory: (show: boolean) => void;
}

const createAppStateSlice = (set: any): AppStateSlice => ({
    showSigningInInventory: false,
    setShowSigningInInventory: (show) => set({ showSigningInInventory: show }),
});

export { createAppStateSlice };
export type { AppStateSlice };
